export default {
    // 通用
    pageTitle: '合规出入金开户',
    compliancePageTitle: '复星国际证券客户资料复核',
    confirm: '确认',
    cancel: '取消',
    next: '下一步',
    previous: '上一步',
    save: '保存',
    submit: '提交',
    complete: '完成',
    loading: '加载中...',
    
    // 页面标题
    complianceIndex: '合规出入金开户',
    passwordVerify: '交易密码验证',
    jobStatus: '职业状况',
    finance: '财务状态',
    informationSupplement: '补充信息',
    backgroundDisclosure: '背景状况披露',
    signature: '签署姓名',
    complianceAudit: '合规审核',
    status: '审核状态',

    // jobStatus 翻译键
    jobStatus: {
        // 基础信息
        zyzk: '职业状况',
        zgxl: '最高学历',
        qxzzgxl: '请选择最高学历',
        zyzt: '职业状态',
        qxzzyzt: '请选择职业状态',
        gsmc: '公司名称',
        qsrgsmc: '请输入公司名称',
        selectGs: '请选择公司',
        bgsdz: '办公室地址',
        qsrbgsdzxx: '请输入办公室地址信息',
        hangye: '公司行业',
        qxzhy: '请选择公司行业',
        zhiwei: '职位',
        qxzzy: '请选择职位',
        gznq: '工作年期',
        qxzgznq: '请选择工作年期',

        // 学历选项
        xxhyx: '小学或以下',
        zhongxue: '中学',
        ykhzsxy: '预科或专上学院',
        dx: '大学',
        sshys: '硕士或以上',

        // 职业状态选项
        sg: '受雇',
        zg: '自雇',
        tx: '退休',
        xs: '学生',
        wy: '无业',

        // 投资来源
        tzzjlydx: '投资资金来源（多选）',
        jiating: '家庭',
        jianzhixinjin: '兼职薪金',
        zujin: '租金',
        tuixiujin: '退休金',
        fdctzsy: '房地产投资收益',
        jrsctzsy: '金融市场投资收益',
        qtlwbc: '其他劳务报酬',

        // 财务状况
        cwzk: '债务状况',
        wzw: '无债务',
        fd: '房贷',
        qtzw: '其他债务',
        brwzwjf: '本人无债务纠纷',
        yzwjfzbzckh: '有债务纠纷，请联系客服进行线下开户。',

        // 公司搜索
        wgsxx: '无公司信息',
        xzhy: '选择行业',
        inputCompanyInfo: '填写公司信息',
        qsrgsWZmcPlaceholder: '公司名称不能少于4个字',
        CompanyAddressTip: '请确认公司地址准确无误',
        SamePrompt: '公司名称和地址不能相同',

        // 职位选项
        gaoguan: '高管',
        zhongceng: '中层',
        chujiguanli: '初级管理人员',
        putongyuangong: '普通员工',
        hehuoren: '合伙人',
        faren: '法人',
        zongjinli: '总经理',

        // 工作年限选项
        shaoyuyinian: '少于1年',
        yidaoliangnian: '1-2年',
        sandaowunian: '3-5年',
        liudaojiunian: '6-9年',
        shinianyishang: '10年及以上',

        // 行业选项
        nlmy: '农林牧渔',
        cky: '采矿业',
        zzy: '制造业',
        jzy: '建筑业',
        dlrlrqjsqschgy: '电力、热力、燃气及水生产和供应业',
        jry: '金融业',
        fdcy: '房地产业',
        pfhlsy: '批发和零售业',
        zlhsfwy: '租赁和商务服务业',
        zshcyy: '住宿和餐饮业',
        xxcsrjxx: '信息传输、软件和信息技术服务业',
        kxyjhjsfw: '科学研究和技术服务业',
        jtyscchyz: '交通运输、仓储和邮政业',
        jy: '教育',
        slhjhggssgly: '水利、环境和公共设施管理业',
        wshshgz: '卫生和社会工作',
        whtyyl: '文化、体育和娱乐业',
        ggglhshbz: '公共管理、社会保障和社会组织',
        jmfwxlother: '居民服务、修理和其他服务业',
        guojizuzhi: '国际组织',
        gyjz: '工业/建筑',
        jrsy: '金融/商业',
        xxjskx: '信息技术/科学',
        ggshjt: '公共/社会/交通',
        guoji: '国际',

        // 提示信息
        xlbxdyxz: '学历必须大于小学',
        CompanyAddressTip: '请完整填写xx市xx区xx街道xx楼栋xx楼层xx室',
    },

    // Finance 财务状况翻译键
    Finance: {
        // 基础信息
        cwzk: '财务状况',
        zjly: '资金来源（多选）',
        qnsr: '全年收入',
        qxzqnsr: '请选择全年收入',
        jzc: '净资产',
        qxzjzc: '请选择净资产',
        kyztzdldzcjz: '可用于投资的净资产',
        qxzkyztzdldzc: '请选择可用于投资的净资产',
        mnpjtzje: '每年平均投资金额',
        qxzmnpjtzje: '请选择每年平均投资金额',
        zzlb: '住宅类别',

        // 资金来源选项
        xjywsr: '薪金/业务收入',
        grcx: '个人储蓄',
        zcjc: '资产继承',
        tzsy: '投资收益',
        zczs: '资产转售',

        // 收入范围选项
        '20wanyixia': '20万以下',
        '20wandao50wan': '20万-50万',
        '50wandao100wan': '50万-100万',
        '100wandao500wan': '100万-500万',
        '500wandao1000wan': '500万-1000万',
        '1000wanyishang': '1000万以上',

        // 资产范围选项
        '100wanyixia': '100万以下',
        '100wandao300wan': '100万-300万',
        '300wandao500wan': '300万-500万',
        '500wandao700wan': '500万-700万',
        '700wandao1000wan': '700万-1000万',

        // 住宅类别选项
        sushe: '宿舍',
        yjrtz: '与家人同住',
        zufang: '租房',
        anjiewuye: '按揭物业',
        zizhiwuye: '自置物业',

        // 提示信息
        jzcbysykytzdldzc: '净资产不应少于可用于投资的净资产',
    },

    // BackgroundDisclosure 背景披露翻译键
    BackgroundDisclosure: {
        title: '背景状况披露',
        politicalPersonTitle: '您是否为政治敏感人员或与政治敏感人员有关联？',
        fatfMemberTitle: '您是否来自FATF成员国？',
        highRiskIndustryTitle: '您是否从事高风险行业？',
        otherRiskFactorsTitle: '您是否存在其他高风险因素？',
        yes: '是',
        no: '否',
        politicalPersonDetailLabel: '请填写详细说明',
        politicalPersonDetailPlaceholder: '请说明您是政治敏感人员的原因',
        fatfMemberDetailLabel: '请填写详细说明',
        fatfMemberDetailPlaceholder: '请说明您来自FATF成员国的原因',
        highRiskIndustryDetailLabel: '请填写详细说明',
        highRiskIndustryDetailPlaceholder: '请说明您从事高风险行业的原因',
        otherRiskFactorsDetailLabel: '请填写详细说明',
        otherRiskFactorsDetailPlaceholder: '请说明您存在其他高风险因素的原因',
    },

    // InformationSupplement 补充信息翻译键
    InformationSupplement: {
        title: '补充信息',
        fundSourceTitle: '资金来源地（多选）',
        tradingFrequencyTitle: '过去一年每月交投次数',
        thirdPartyTransferTitle: '过去一年是否存在第三者汇入/汇出款项',
        moneyLaunderingTitle: '过去一年是否牵涉关于洗钱的诉讼',
        spouseAccountTitle: '您的配偶、您自己是否存在与配偶共同操作另一个复星国际证券的账户',
        yes: '是',
        no: '否',
        fundSourceOptions: {
            hongkong: '香港',
            mainland: '中国大陆',
            macau: '澳门',
            singapore: '新加坡',
            usa: '美国',
            canada: '加拿大',
            other: '其他'
        },
        fundSourceOtherLabel: '请填写具体的资金来源地',
        fundSourceOtherPlaceholder: '请输入',
        thirdPartyTransferDetailLabel: '请填写详细说明',
        thirdPartyTransferDetailPlaceholder: '请输入第三者汇入/汇出款项的详细说明',
        moneyLaunderingDetailLabel: '请填写详细说明',
        moneyLaunderingDetailPlaceholder: '请输入洗钱诉讼的详细说明',
        spouseAccountLabel: '账户号',
        spouseAccountPlaceholder: '请输入账户号码',
        tradingFrequencyOptions: {
            lessThan1: '少于1次',
            '1to10': '1-10次',
            '11to20': '11-20次',
            moreThan21: '20次以上'
        }
    },

    // Signature 签名翻译键
    Signature: {
        title: '客户签名',
        defaultName: '客户',
        signSuccess: '签名成功',
        signFailed: '签名失败，请重试',
        pleaseSign: '请在下方区域内签名',
        signTip: '请使用手指或触控笔在下方区域内签署您的姓名',
        uploadingSignature: '正在上传签名...',
        submittingData: '正在提交资料...',
        submitSuccess: '合规资料提交成功！',
        submitFailed: '提交失败，请重试',
    },

    // 职业状况页面
    jobStatusPage: {
        title: '职业状况',
        subtitle: '请填写您的职业相关信息',
        education: '教育程度',
        employment: '就业状况',
        companyName: '公司名称',
        companyAddress: '公司地址',
        industry: '行业',
        position: '职位',
        workYears: '工作年限',
        
        // 教育程度选项
        educationOptions: {
            highSchool: '高中及以下',
            college: '大专',
            bachelor: '本科',
            master: '硕士',
            doctor: '博士'
        },
        
        // 就业状况选项
        employmentOptions: {
            employed: '在职',
            selfEmployed: '自雇',
            unemployed: '无业',
            retired: '退休',
            student: '学生'
        },
        
        // 工作年限选项
        workYearsOptions: {
            lessThan1: '少于1年',
            oneToThree: '1-3年',
            threeToFive: '3-5年',
            fiveToTen: '5-10年',
            moreThanTen: '10年以上'
        },
        
        // 验证信息
        validation: {
            educationRequired: '请选择教育程度',
            employmentRequired: '请选择就业状况',
            companyNameRequired: '请输入公司名称',
            companyAddressRequired: '请输入公司地址',
            industryRequired: '请选择行业',
            positionRequired: '请输入职位',
            workYearsRequired: '请选择工作年限'
        }
    },
    
    // 财务状态页面
    financePage: {
        title: '财务状态',
        subtitle: '请填写您的财务相关信息',
        annualIncome: '年收入',
        netWorth: '净资产',
        investmentExperience: '投资经验',
        riskTolerance: '风险承受能力',
        investmentObjective: '投资目标'
    },
    
    // 补充信息页面
    supplementPage: {
        title: '补充信息',
        subtitle: '请填写补充信息',
        politicallyExposed: '是否为政治敏感人员',
        pepDetails: 'PEP详情',
        sourceOfFunds: '资金来源',
        expectedTransactionVolume: '预期交易量'
    },
    
    // 背景状况披露页面
    backgroundPage: {
        title: '背景状况披露',
        subtitle: '请如实填写背景信息',
        criminalRecord: '是否有犯罪记录',
        criminalDetails: '犯罪记录详情',
        bankruptcyRecord: '是否有破产记录',
        bankruptcyDetails: '破产记录详情',
        regulatoryAction: '是否受过监管处罚',
        regulatoryDetails: '监管处罚详情'
    },
    
    // 签署页面
    signaturePage: {
        title: '签署姓名',
        subtitle: '请签署您的姓名',
        signature: '签名',
        signatureDate: '签署日期',
        agreement: '我确认以上信息真实有效'
    },
    
    // 合规审核页面
    auditPage: {
        title: '合规审核',
        subtitle: '您的申请正在审核中',
        status: '审核状态',
        pending: '审核中',
        approved: '已通过',
        rejected: '已拒绝',
        reviewDate: '审核日期',
        reviewComments: '审核意见'
    },
    
    // C_SearchCompany 相关文案
    'C_SearchCompany': {
        noSearch: '查不到公司?',
        searchNoData: '暂无搜索结果',
        inputCompanyInfo: '填写公司信息'
    },

    // 通用按钮文案
    determine: '确定',

    // 合规状态页面
    complianceStatus: {
        defaultRejectReason: '资料审核不通过',
        commonRejectReasons: {
            documentUnclear: '提供的证明文件不清晰，请重新上传高清版本',
            documentIncomplete: '资料不完整，请补充相关证明文件',
            informationInconsistent: '提供的信息前后不一致，请核实后重新填写',
            documentExpired: '提供的证明文件已过期，请上传有效期内的文件',
            signatureInvalid: '签名不符合要求，请重新签署'
        }
    },

    // 错误信息
    errors: {
        networkError: '网络错误，请重试',
        validationError: '请检查输入信息',
        submitError: '提交失败，请重试',
        loadError: '加载失败，请刷新页面'
    },
    
    // 状态页面
    ComplianceStatus: {
        // 基本信息
        xingming: '姓名：',
        henglihao: '恒利号：',

        // 状态标题
        shz: '审核中',
        bh: '审核驳回',
        wc: '审核通过',
        sb: '审核失败',
        khcg: '合规审核通过',

        // 状态描述
        yjydlrkt: '已经提交申请，请耐心等待审核',
        qbczl: '请补充资料后重新提交',
        hgcg: '恭喜您，合规审核已通过',
        hgsb: '很抱歉，合规审核未通过',

        // 按钮文本
        bckhzl: '补充开户资料',
        zlshbtg: '资料审核不通过',

        // 其他
        service: '客服'
    },

    // 成功信息
    success: {
        saved: '保存成功',
        submitted: '提交成功',
        completed: '完成'
    }
}
